export enum Recurrence {
  DAILY = 'daily',
  WEEKLY = 'weekly',
  MONTHLY = 'monthly',
  QUARTERLY = 'quarterly',
  ANNUALLY = 'financial_year',
  OPT_OUT_THIS = 'opt-out-this',
  OPT_OUT_ALL = 'opt-out-all'
}

export enum RecurrenceWeekDay {
  MONDAY = 'monday',
  TUESDAY = 'tuesday',
  WEDNESDAY = 'wednesday',
  THURSDAY = 'thursday',
  FRIDAY = 'friday',
  SATURDAY = 'saturday',
  SUNDAY = 'sunday'
}

export enum RecurrenceEndType {
  ON_THIS_DAY = 'end-date',
  AFTER_N_OCCURANCES = 'end-after-occurrences',
  NEVER = 'does-not-end'
}

export const THE_LAST = 'the_last';
